import { render } from "./SampleItem.vue?vue&type=template&id=1f0a25ba&scoped=true"
import script from "./SampleItem.vue?vue&type=script&lang=js"
export * from "./SampleItem.vue?vue&type=script&lang=js"

import "./SampleItem.vue?vue&type=style&index=0&id=1f0a25ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0a25ba"]])

export default __exports__